module.exports = __webpack_public_path__ + "img/appaga_logo.2b8a2eff.jpg";